import { useEffect, useState } from 'react';
import { adminService } from '../services/AdminService';
import { useAuthSafe } from '../contexts/AuthContext';

/** Is `flagName` on for the signed-in user's organization? Org row wins over
 *  the global row (same precedence as the backend gate); solo users (no org)
 *  read the global row; outside an AuthProvider (guest / portal) it is false. */
export function useOrgFeatureFlag(flagName: string): boolean {
  const auth = useAuthSafe();
  const orgId = auth?.currentUser?.organization_id;
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    if (!auth?.currentUser) { setEnabled(false); return; }
    let live = true;
    const flag = orgId
      ? adminService.getOrgFeatureFlagPublic(orgId, flagName)
      : adminService.getGlobalFeatureFlagPublic(flagName);
    flag.then(res => { if (live) setEnabled(!!res.data?.is_enabled); }).catch(() => { if (live) setEnabled(false); });
    return () => { live = false; };
  }, [orgId, flagName, !!auth?.currentUser]);
  return enabled;
}
